import {CommonModule} from '@angular/common';
import {CUSTOM_ELEMENTS_SCHEMA, Injector, NgModule} from '@angular/core';
import {CustomElementService} from '../../../../formbird-sc-shared/src/lib/services/custom-element.service';
import {ComponentSetupModule} from '../../../../formbird-sc-shared/src/lib/component-setup.module';
import { AvlSpeedGmapComponent } from './avl-speed-gmap.component';
import { default as pjson } from '../../../../../package.json';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatInputModule} from '@angular/material/input';

@NgModule({
  declarations: [
    AvlSpeedGmapComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    ComponentSetupModule,
    MatFormFieldModule,
    MatTooltipModule,
    MatInputModule,
  ],
  exports: [
    AvlSpeedGmapComponent
  ],
  providers: [
  ]
})

export class AvlSpeedGmapModule {
  constructor(private injector: Injector, private customElementService: CustomElementService ) {
    customElementService.convertToCustomElement(AvlSpeedGmapComponent, 'sc-avl-speed-gmap', this.injector, pjson.version);

  }
}
